import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEditAssignmentMutation } from "../../../../features/assignment/assignmentApi";
import { useGetVideosQuery } from "../../../../features/videos/videosApi";
import SelectList from "../../../ui/SelectList";
import MessageToast from "../../../ui/MessageToast";

export default function EditAssignmentForm({ assignment }) {
	const { data: videos, isSuccess: isGetVideosQuerySuccess } =
		useGetVideosQuery() || {};

	let videosSelectOptions = [];
	if (isGetVideosQuerySuccess) {
		videosSelectOptions = videos.map((video) => ({
			id: video.id,
			text: video.title,
		}));
	}

	const {
		id,
		title: initialTitle,
		video_id: initialVideoId,
		totalMark: initialTotalMark,
	} = assignment || {};

	const [title, setTitle] = useState(initialTitle);
	const [video_id, setVideoId] = useState(initialVideoId);
	const [totalMark, setTotalMark] = useState(initialTotalMark);

	const [
		editAssignment,
		{ isLoading, isError: isEditAssignmentError, isSuccess },
	] = useEditAssignmentMutation() || [];
	const navigate = useNavigate();

	useEffect(() => {
		if (isSuccess) {
			navigate("/admin/assignments");
		}
	}, [isSuccess, navigate]);

	const handleFormSubmit = (e) => {
		e.preventDefault();
		const videoTitle = videos.find((v) => v.id == video_id)?.title;

		const updatedData = {
			title,
			video_id: Number(video_id),
			video_title: videoTitle,
			totalMark,
		};

		editAssignment({ id, data: updatedData });
	};

	return (
		<>
			<div>
				<h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
					Edit Assignment
				</h2>
			</div>
			<form onSubmit={handleFormSubmit} className="mt-8 space-y-6">
				<div className="rounded-md shadow-sm ">
					<div>
						<label className="text-sm font-bold">Title:</label>
						<input
							value={title}
							onChange={(e) => setTitle(e.target.value)}
							id="name"
							name="name"
							type="name"
							autoComplete="name"
							required
							className="login-input rounded-t-md"
							placeholder="Assignment title"
						/>
					</div>
					<div className="mt-4">
						<label className="text-sm font-bold">
							Select video to attach:
						</label>
						<SelectList
							options={videosSelectOptions}
							value={video_id}
							setValue={setVideoId}
							defaultText="Select video"
							className="login-input rounded-t-md"
							required
						/>
					</div>
					<div className="mt-4">
						<label className="text-sm font-bold">Total mark:</label>
						<input
							value={totalMark}
							onChange={(e) => setTotalMark(e.target.value)}
							id="assignment-mark"
							name="assignment-mark"
							type="number"
							autoComplete="assignment-mark"
							required
							className="login-input"
							placeholder="Assignment mark"
						/>
					</div>
				</div>

				<div className="flex justify-center">
					<button
						disabled={isLoading}
						type="submit"
						className="group relative flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
					>
						Update
					</button>
				</div>
			</form>

			{isEditAssignmentError && (
				<MessageToast 
					message="There was an error while assignment edit" 
					type="error"	
					delay={3000}
				/>
			)}
		</>
	);
}
